import { render } from "./BlogThree.vue?vue&type=template&id=123bba54&scoped=true"
import script from "./BlogThree.vue?vue&type=script&lang=js"
export * from "./BlogThree.vue?vue&type=script&lang=js"

import "./BlogThree.vue?vue&type=style&index=0&id=123bba54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123bba54"]])

export default __exports__